var React = require('react');

function CloseIconInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"26.1621","y":"8.48523","width":"2","height":"25","transform":"rotate(45 26.1621 8.48523)","fill":"currentColor","key":0}),React.createElement("rect",{"x":"27.2246","y":"25.8094","width":"2","height":"25","transform":"rotate(135 27.2246 25.8094)","fill":"currentColor","key":1})]);
}

CloseIconInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = CloseIconInline;

CloseIconInline.default = CloseIconInline;
